// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { zksyncSepoliaTestnet as _zksyncSepoliaTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the zksyncSepoliaTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 300
 * Chain Name: ZKsync Sepolia Testnet
 * Default Block Explorer: https://sepolia-era.zksync.network/
 * Default RPC URL: https://sepolia.era.zksync.dev
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { zksyncSepoliaTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: zksyncSepoliaTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const zksyncSepoliaTestnet = createCommon({
	..._zksyncSepoliaTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
